module.exports = __webpack_public_path__ + "img/dark-chart-to-settings.f8e1bc65.svg";